//import Libraries
import React, { Component } from 'react';
import { connect } from 'react-redux';

//import Components
import Layout from '../../hoc/Layout/Layout'
import SubNavigation from './SubNavigation/SubNavigation';
import Contents from './Contents/Contents';
import Fullpage from '../../hoc/Fullpage/Fullpage';
import Language from '../../language/language.json';
import TitleSection from '../../components/TitleSection/TitleSection';

import * as homeActions from '../../pages/Home/actions/homeActions';

//import Style classes
import './DepartmentModule.css'

class DepartmentModule extends Component{
    constructor(props){
        super(props);
        this.state = {
            page:  this.props.page ? this.props.page : 0
        }
    }

    navClickHandler = (idx)=>{
        this.setState({page: idx});
    }

    data = this.props.type === "engineering" ? this.props.company[0] : this.props.company[1];
    
    componentDidMount(){
        this.setState({page: this.props.page ? this.props.page : 0})

        if (!this.props.company[0].subDepartments[0].items ||
            !this.props.company[0].subDepartments[1].items ||
            !this.props.company[1].subDepartments[0].items ||
            !this.props.company[1].subDepartments[1].items ||
            !this.props.company[1].subDepartments[2].items ||
            !this.props.company[2].items) {
                this.props.onLoadDepartment('constructions');
                this.props.onLoadDepartment('materials');
                this.props.onLoadDepartment('fertilizers');
                this.props.onLoadDepartment('mediums');
                this.props.onLoadDepartment('extras');
                this.props.onLoadDepartment('cards');
        }
    }
    componentDidUpdate(prevProps, prevState){
        if(!(prevState.page === this.state.page)){
            this.setState({page: this.props.page ? this.props.page : 0})
        }
        if(!(prevProps === this.props)){
            this.setState({page: this.props.page ? this.props.page : 0})
        }
    }
    render(){
        if (!this.props.company[0].subDepartments[0].items ||
            !this.props.company[0].subDepartments[1].items ||
            !this.props.company[1].subDepartments[0].items ||
            !this.props.company[1].subDepartments[1].items ||
            !this.props.company[1].subDepartments[2].items ||
            !this.props.company[2].items) {
                return (
                    <Layout store={false} relative={true}>
                        {this.props.type === "engineering" ? null : 
                        <SubNavigation 
                            type={this.props.type}
                            clickHandler={this.navClickHandler}
                            page={this.state.page}
                            lang={this.props.universal.language} 
                            data={this.data} 
                            universal={this.props.universal}/>
                        }
                    </Layout>
                )
        }

        // console.log("[DepartmentModule.js]", this.data)
        const titleSectionData = {
            type: "icon",
            id: this.props.type + this.state.page,
            title: this.data.subDepartments[this.state.page].name,
            content: this.data.subDepartments[this.state.page].content
        }
        const pageContent = (
            <div>
                <Fullpage className="ModuleMain" padding="0px" backgroundColor="--main-bg-3" height="70vh">
                    <img src={require("../../assets/department-module/"+this.props.type+this.state.page+".jpg")}/>
                </Fullpage>
                <TitleSection data={titleSectionData} lang={this.props.universal.language}/>
                <Contents 
                    data={this.data.subDepartments[this.state.page]}
                    lang={this.props.universal.language} />
            </div>
        );
        return (
            <Layout store={false} relative={true}>
                {this.props.type === "engineering" ? null : 
                <SubNavigation 
                    type={this.props.type}
                    clickHandler={this.navClickHandler}
                    page={this.state.page}
                    lang={this.props.universal.language} 
                    data={this.data} 
                    universal={this.props.universal}/>
                }
                {pageContent}
            </Layout>
        )
    }
}

const mapStateToProps = (state) => {
    return { 
        universal: state.universal,
        company : state.company
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        onLoadDepartment : (subDepartment) => {
            dispatch(homeActions.loadDepartment(subDepartment))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentModule);


// WEBPACK FOOTER //
// ./src/components/DepartmentModule/DepartmentModule.js